import { AgGridReact, AgGridReactProps } from 'ag-grid-react'
import { Box } from '@mui/material'
import { AG_GRID_THEME } from '../BulkSheet/const'
import React, { Ref, useCallback, useMemo, useState } from 'react'
import { onCellSelectionChanged } from './gridEventCallback'
import { getUrlQueryObject } from '../../../utils/urls'
import { GridOptions, GridReadyEvent } from 'ag-grid-community'
import { processDataFromClipboard } from '../commons/AgGrid'

type Props = Omit<AgGridReactProps, 'gridOptions'> & {
  gridRef?: Ref<AgGridReact>
  gridOptions?: GridOptions
}
export const BulkSheetView = React.forwardRef<HTMLDivElement, Props>(
  (props: Props, ref: React.Ref<HTMLDivElement>) => {
    const rowBuffer = useMemo(() => {
      const urlQueryString = getUrlQueryObject()
      return !isNaN(Number(urlQueryString?.rowBuffer))
        ? (urlQueryString.rowBuffer as number)
        : 10
    }, [])

    const [copyHeadersToClipboard, setCopyHeadersToClipboard] = useState(false)
    const onKeyDown = useCallback(
      e => {
        setCopyHeadersToClipboard(e.shiftKey)
      },
      [setCopyHeadersToClipboard]
    )

    const [sideBarConfig, setSideBarConfig] = useState({
      toolPanels: [
        {
          id: 'columns',
          labelDefault: '',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          toolPanelParams: {
            suppressPivotMode: true,
            suppressValues: true,
            suppressRowGroups: true,
          },
        },
      ],
      defaultToolPanel: '',
    })

    const onGridReady = useCallback(
      (event: GridReadyEvent) => {
        if (props.onGridReady) {
          ;(props.onGridReady as (event: GridReadyEvent) => void)(event)
        }
      },
      [props.onGridReady]
    )

    return (
      <Box
        ref={ref}
        className={AG_GRID_THEME}
        sx={{
          width: '100%',
          height: '100%',
          padding: '0 8px 8px',
        }}
        onKeyDown={onKeyDown}
      >
        <AgGridReact
          ref={props.gridRef}
          getRowId={params => params.data.uuid}
          getDataPath={data => data.treeValue}
          rowBuffer={rowBuffer}
          animateRows={true}
          suppressGroupRowsSticky={true}
          suppressColumnVirtualisation={true}
          rowSelection={{
            mode: 'multiRow',
            checkboxes: false,
            headerCheckbox: false,
          }}
          cellSelection={true}
          undoRedoCellEditing={true}
          suppressOverlays={[
            'noRows',
            'noMatchingRows',
            'loading',
            'exporting',
          ]}
          onCellSelectionChanged={onCellSelectionChanged}
          processDataFromClipboard={processDataFromClipboard}
          copyHeadersToClipboard={copyHeadersToClipboard}
          sideBar={sideBarConfig}
          {...(props as AgGridReactProps)}
          theme="legacy"
          onGridReady={onGridReady}
        />
      </Box>
    )
  }
)
